import script from "./cpt-scroll-list-option.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-scroll-list-option.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__